export default "__VITE_ASSET__C_kiWSKj__"